import styled from 'styled-components';
import { isNot } from 'typescript-styled-is';
import React from 'react';
import { Flex } from '@ui-library/misc';
import { LabelMedium } from '@ui-library/typography';
import theme from '@css/theme';

interface CardProp {
  notPadded?: boolean;
}

export const Card = styled.div<CardProp>`
  background-color: #fff;
  border: 1px solid ${theme.color.border};
  border-radius: 4px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  ${isNot('notPadded')`
    padding: 24px 32px;
  `};
`;

const CardContent = styled.div`
  padding: 24px 32px;
`;

const Header = styled(Flex)`
  background: #f7f9fa;
  border-radius: 7px 7px 0 0;
  padding: 16px 32px;
`;

interface IProps {
  children: React.ReactNode;
  title: string;
  tag?: string;
  className?: string;
  noContentPadding?: boolean;
}

export const HeaderCard = ({ children, title, tag, className, noContentPadding }: IProps) => (
  <Card notPadded className={className} data-testid="card">
    <Header spaceBetween>
      <LabelMedium color={theme.color.neutral1} fontWeight={700} data-testid="title">
        {title}
      </LabelMedium>
      {tag && (
        <LabelMedium color={theme.color.neutral1} fontWeight={500} data-testid="tag">
          {tag}
        </LabelMedium>
      )}
    </Header>
    {noContentPadding ? children : <CardContent>{children}</CardContent>}
  </Card>
);
